module.exports = __webpack_public_path__ + "static/Microsoft-Logo-a9bb130db07da8a3faa41434465f5ba5.png";